import {
    array,
    boolean,
    nativeEnum,
    number,
    object,
    string,
    TypeOf,
} from 'zod';

import { ISO6391 } from '../../ISO-639-1';
import { Link } from '../common';
import { ProductMediaTrailer } from './trailer';

/* ------------------------------ ProductPrice ------------------------------ */

export const ProductPrice = object({
    priceBandId: string(),
    currency: string(),
    value: number(),
    accessWindow: string(),
    viewingWindow: string(),
});

export type ProductPrice = TypeOf<typeof ProductPrice>;

/* --------------------------- ProductAvailability -------------------------- */

export const ProductAvailability = object({
    comingSoon: object({
        releaseDate: string().optional(),
        preOrder: ProductPrice.optional(),
    }).optional(),
    fvod: boolean(),
    svod: array(string()).optional(),
    tvod: ProductPrice.optional(),
    entitled: boolean(),
    entitlement: object({
        type: string().optional(), // rental or subscription
        accessibleFor: string().optional(),
        viewableFor: string().optional(),
        availableFrom: string().optional(),
    }).optional(),
});

export type ProductAvailability = TypeOf<typeof ProductAvailability>;

/* ----------------------------- ProductProgress ---------------------------- */

export const ProductProgress = object({
    elapsed: string(),
    duration: string().optional(),
    progress: number().optional(),
});

export type ProductProgress = TypeOf<typeof ProductProgress>;

/* ------------------------------ ProductLabel ------------------------------ */

export const ProductLabel = object({
    tileLabelId: string().optional(),
    itemLabelId: string().optional(),
});

export type ProductLabel = TypeOf<typeof ProductLabel>;

/* ------------------------------ ProductLinks ------------------------------ */

export const ProductLinks = array(Link);
export type ProductLinks = TypeOf<typeof ProductLinks>;

/* ------------------------------ ProductExtend ----------------------------- */

export const ProductExtend = object({
    availability: ProductAvailability.optional(),
    favourite: boolean().optional(),
    feature: object({
        audioTracks: nativeEnum(ISO6391).array(),
        subtitles: nativeEnum(ISO6391).array(),
    }).optional(),
    label: ProductLabel.optional(),
    trailer: ProductMediaTrailer.optional(),
    progress: ProductProgress.optional(),
    links: ProductLinks.optional(),
});

export type ProductExtend = TypeOf<typeof ProductExtend>;
